import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OwnershipLevel } from '@fitness-force/enum';
import { AppErrors, BadRequestError, NotFoundError } from '@fitness-force/errors';
import { CreateWhatsappTemplate, ListWhatsAppTemplateMaster, ListWhatsAppTemplateMasterResponse, UpdateWhatsAppTemplate, WhatsAppTemplateMaster } from '@fitness-force/models';
import { environment } from 'apps/ff-frontend/src/environments/environment';
import { map, catchError, throwError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WhatsappTemplateMasterService {

  constructor(private http: HttpClient, private router: Router) {}
  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  ListWhatsAppSTemplateMaster(tenantId: number): Observable<ListWhatsAppTemplateMasterResponse> {
    return this.http.get<ListWhatsAppTemplateMasterResponse>(
        `${environment.BASE_URL}/tenants/${tenantId}/whatsapp_template_master`,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  WhatsAppTemplateMaster(tenantId: number, notificationId:number, templateId:number): Observable<WhatsAppTemplateMaster> {
    return this.http.get<WhatsAppTemplateMaster>(
        `${environment.BASE_URL}/tenants/${tenantId}/notifications/${notificationId}/whatsapp_template_master/${templateId}`,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  GetWhatsAppTemplateMaster(tenantId: number, templateId:number): Observable<WhatsAppTemplateMaster> {
    return this.http.get<WhatsAppTemplateMaster>(
        `${environment.BASE_URL}/tenants/${tenantId}/whatsapp_template_master/${templateId}`,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  
  UpdateWhatsappTemplateMasterStatusActiveByOwnership(ownership:OwnershipLevel, tenantId: number, franchiseGroupId: number, templateId:number): Observable<any> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = `${environment.BASE_URL}/companies/whatsapp_template_master/${templateId}/mark_as_active`;
        break;
      case OwnershipLevel.Franchise:
        url = `${environment.BASE_URL}/franchise_group/${franchiseGroupId}/whatsapp_template_master/${templateId}/mark_as_active`;
        break;
      case OwnershipLevel.Tenant:
        url = `${environment.BASE_URL}/tenants/${tenantId}/whatsapp_template_master/${templateId}/mark_as_active`;
        break;
      default:
        url = `${environment.BASE_URL}/tenants/${tenantId}/whatsapp_template_master/${templateId}/mark_as_active`;
        break;
    }
    return this.http.post<any>(
        url,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  UpdateWhatsappTemplateMasterStatusInActiveByOwnership(ownership:OwnershipLevel, tenantId: number, franchiseGroupId:number, templateId:number): Observable<any> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = `${environment.BASE_URL}/companies/whatsapp_template_master/${templateId}/mark_as_inactive`;
        break;
      case OwnershipLevel.Franchise:
        url = `${environment.BASE_URL}/franchise_group/${franchiseGroupId}/whatsapp_template_master/${templateId}/mark_as_inactive`;
        break;
      case OwnershipLevel.Tenant:
        url = `${environment.BASE_URL}/tenants/${tenantId}/whatsapp_template_master/${templateId}/mark_as_inactive`;
        break;
      default:
        url = `${environment.BASE_URL}/tenants/${tenantId}/whatsapp_template_master/${templateId}/mark_as_inactive`;
        break;
    }
    return this.http.post<any>(
        url,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  UpdateWhatsappTemplateMasterStatusActive(tenantId: number, templateId:number): Observable<any> {
    return this.http.post<any>(
        `${environment.BASE_URL}/tenants/${tenantId}/whatsapp_template_master/${templateId}/mark_as_active`,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  UpdateWhatsappTemplateMasterStatusInActive(tenantId: number, templateId:number): Observable<any> {
    return this.http.post<any>(
        `${environment.BASE_URL}/tenants/${tenantId}/whatsapp_template_master/${templateId}/mark_as_inactive`,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }   

  CreateWhatsappTemplate(ownership:OwnershipLevel, payload:CreateWhatsappTemplate, tenantId:number, franchiseGroupId:number): Observable<any> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = `${environment.BASE_URL}/companies/whatsapp_template_master`;
        break;
      case OwnershipLevel.Franchise:
        url = `${environment.BASE_URL}/franchise_group/${franchiseGroupId}/whatsapp_template_master`;
        break;
      case OwnershipLevel.Tenant:
        url = `${environment.BASE_URL}/tenants/${tenantId}/whatsapp_template_master`;
        break;
      default:
        url = `${environment.BASE_URL}/tenants/${tenantId}/whatsapp_template_master`
        break;
    }
    return this.http.post(url,payload, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  UpdateWhatsappTemplate(ownership:OwnershipLevel, templateId:number, updatePayload:UpdateWhatsAppTemplate, tenantId:number, franchiseGroupId:number): Observable<any> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = `${environment.BASE_URL}/companies/whatsapp_template_master/${templateId}`;
        break;
      case OwnershipLevel.Franchise:
        url = `${environment.BASE_URL}/franchise_group/${franchiseGroupId}/whatsapp_template_master/${templateId}`;
        break;
      case OwnershipLevel.Tenant:
        url = `${environment.BASE_URL}/tenants/${tenantId}/whatsapp_template_master/${templateId}`;
        break;
      default:
        url = `${environment.BASE_URL}/tenants/${tenantId}/whatsapp_template_master/${templateId}`
        break;
    }
    return this.http.put(url, updatePayload, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getWhatsappTemplatesByOwnership(ownership:OwnershipLevel, tenantId:number, franchiseGroupId:number): Observable<ListWhatsAppTemplateMaster> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = `${environment.BASE_URL}/companies/whatsapp_template_master`;
        break;
      case OwnershipLevel.Franchise:
        url = `${environment.BASE_URL}/franchise_group/${franchiseGroupId}/whatsapp_template_master`;
        break;
      case OwnershipLevel.Tenant:
        url = `${environment.BASE_URL}/tenants/${tenantId}/whatsapp_template_master`;
        break;
      default:
        url = `${environment.BASE_URL}/tenants/${tenantId}/whatsapp_template_master`
        break;
    }
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }


  GetWhatsAppTemplateMasterByOwnership(ownership:OwnershipLevel, templateId:number,franchiseGroupId:number,tenantId:number): Observable<WhatsAppTemplateMaster> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = `${environment.BASE_URL}/companies/whatsapp_template_master/${templateId}`
        break;
      case OwnershipLevel.Franchise:
        url = `${environment.BASE_URL}/franchise_group/${franchiseGroupId}/whatsapp_template_master/${templateId}`;
        break;
      case OwnershipLevel.Tenant:
        url = `${environment.BASE_URL}/tenants/${tenantId}/whatsapp_template_master/${templateId}`
        break;
      default:
        break;
    }
    return this.http.get<WhatsAppTemplateMaster>(url,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

}
